<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      stripe
      size="mini"
    >
      <el-table-column
        type="selection"
        align="center"
        header-align="center"
        width="55"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        prop="defaultImage"
        :label="$l('INDEX.product_table_label_image') || 'IMAGE'"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <img
            :src="
              scope.row.defaultImageUrl
                ? scope.row.defaultImageUrl
                : '/image/static/img/nopic.jpg'
            "
            style="width: 100%"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="productDesc"
        align="left"
        :label="$l('INDEX.product_table_label_product_desc') || '产品说明'"
        min-width="260"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.sampleStyleNo }}</div>
          <div style="color: red;">{{ scope.row.desc }}</div>
          <div>{{ scope.row.sampleName }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="productTypeName"
        :label="$l('INDEX.product_table_label_spec_fabric') || '规格及面料'"
        min-width="200"
      >
        <template slot-scope="scope">
          <div>Size：{{ scope.row.sampleSpec }}</div>
          <div>Weight：{{ scope.row.sampleWeight }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="factoryPrice"
        :label="$l('INDEX.product_table_label_product_price') || '产品价格'"
        min-width="150"
      >
        <template slot-scope="scope">
          <div>
            {{ $l('table_factoryQuotation') || '工厂报价' }}：{{
              scope.row.costPrice
            }}
          </div>
          <div>
            {{ $l('INDEX.table_label_quotedPrice') || '建议报价' }}：{{
              scope.row.quotedPrice
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="sampleSourceName"
        :label="$l('INDEX.product_table_label_sample_source') || '样品来源'"
        min-width="100"
      ></el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </div>
    </el-table>
  </div>
</template>
<script>
// import { } from '@api/projectManager/infoParticipant'
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      // 选中的数据
      multipleSelection: [],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
  },
}
</script>
